import Card from "components/DesignSystem/Card/Card";
import { EmptyMetrics } from "components/EmptyMetrics/EmptyMetrics";
import { EmptyVendor } from "components/Illustrations/EmptyVendor";
import { TopCustomer } from "types/Models/revenueMetrics";
import { formatAmount } from "utils/foramtAmount";

const BAR_COLORS = [
  "t-bg-purple-40",
  "t-bg-purple-30",
  "t-bg-purple-20",
  "t-bg-purple-10",
  "t-bg-purple-0",
];

export const TopCustomersCard = ({
  topCustomers,
}: {
  topCustomers: TopCustomer[];
}) => {
  const max = Math.max(...topCustomers.map((c) => c.total_revenue), 1);
  const isEmpty = topCustomers.length === 0;
  const isAllZero =
    !isEmpty && topCustomers.every((c) => c.total_revenue === 0);

  return (
    <Card.Root borderRounded="lg" variant="secondary">
      <Card.Header>
        <Card.Title>Top Customers by Revenue</Card.Title>
      </Card.Header>
      <Card.Body className="t-px-5 t-pb-5 t-flex t-flex-col t-gap-4 t-mt-0 sm:t-px-4">
        {isEmpty || isAllZero ? (
          <EmptyMetrics
            illustration={<EmptyVendor />}
            title={isAllZero ? "No revenue recorded" : "No customers found"}
            subtitle={
              isAllZero
                ? "Add transactions or record payments to see your top customers here"
                : "Add transactions to see top customers"
            }
          />
        ) : (
          topCustomers.map((customer, index) => {
            const pct = (customer.total_revenue / max) * 100;
            const barColor = BAR_COLORS[index] || "t-bg-purple-10";

            return (
              <div
                key={customer.item_info.uuid}
                className="t-flex t-flex-col t-gap-1"
              >
                <span className="t-text-body-sm t-text-text-60">
                  {customer.item_info.name}
                </span>
                <div className="t-flex t-items-center t-gap-3">
                  <div className="t-flex-1 t-bg-neutral-0 t-rounded-full t-h-2">
                    <div
                      className={`t-h-2 t-rounded-full ${barColor}`}
                      style={{ width: `${pct}%` }}
                    />
                  </div>
                  <span className="t-text-body-sm t-text-text-30 t-min-w-14 t-text-right">
                    {formatAmount(customer.total_revenue)}
                  </span>
                </div>
              </div>
            );
          })
        )}
      </Card.Body>
    </Card.Root>
  );
};
